export const OrderCancellationReasons = {
  BY_DRIVER: 1,
  BY_CLIENT: 2,
};

export const DisableAutoAcceptMinutes = [15,30,45];
